export default {
  hardware: {
    aws: {
      button_label: `Run on Amazon Braket`,
      modal: {
        description: `
  ![](https://assets.cloud.pennylane.ai/pennylane_website/pages/demonstrations/hardware_modal/braket.png)
  ## Run on Amazon Braket
  See how our demos run on real quantum computers through Amazon [Braket](https://aws.amazon.com/braket/) — a fully managed quantum computing service providing access to different types of quantum hardware and on-demand simulators.
  - Have PennyLane installed already? Check out the code on GitHub below and use the [PennyLane-Braket plugin](https://amazon-braket-pennylane-plugin-python.readthedocs.io/en/latest/).
  - Want to run it without the hassle of setting anything up locally? Check out [Amazon Braket's getting started guide](https://aws.amazon.com/braket/getting-started/).
  
  Be sure to check out the Readme in the GitHub repo below for further instructions.
    `,
        github_link_text: `Visit Amazon Braket GitHub`,
        sign_up_link: {
          text: `Sign-up for Amazon Braket`,
          url: `https://aws.amazon.com/braket/`,
        },
        disclaimer: `
  You will need an Amazon Web Services (AWS) account to run the demo.
  
  All Braket Demo code is maintained by AWS
        `,
      },
    },
    covalent: {
      button_label: `Run on Covalent Cloud`,
      modal: {
        description: `
  ![](https://assets.cloud.pennylane.ai/pennylane_website/pages/demonstrations/hardware_modal/covalent.png)
  ## Run on Covalent Cloud
  See how our demos run on advance compute via [Covalent Cloud](https://covalent.xyz).
  Covalent is an Advanced Computing as a Service platform that enables users to manage and execute high-performance computing tasks,
  such as AI/ML and quantum simulations, on heterogeneous compute resources in a simple, scalable, and cost-effective way.
  - Have PennyLane installed already? Check out the code from the Covalent documentation below and easily use [Covalent with PennyLane](https://docs.covalent.xyz/docs/user-documentation/tutorials/hybrid/).
  - Want to run it without the hassle of setting anything up locally? Check out [Covalent Cloud's getting started guide](https://docs.covalent.xyz/docs/cloud/cloud_quickstart).
    `,
        github_link_text: `View demo in the Covalent Documentation`,
        sign_up_link: {
          text: `Sign-up for Covalent Cloud`,
          url: `https://app.covalent.xyz/register`,
        },
        disclaimer: ``,
      },
    },
    bluequbit: {
      button_label: `Run on BlueQubit`,
      modal: {
        description: `
  ![](https://assets.cloud.pennylane.ai/pennylane_website/pages/demonstrations/hardware_modal/bluequbit.png)
  ## Run on BlueQubit
  You can run this and other circuits on BlueQubit. Here are the devices available:
  - CPU Simulators (up to 34 qubits, FREE)
  - GPU Simulators (up to 36 qubits)
  - Quantum Devices
  
  To learn more — visit our [Getting Started](https://app.bluequbit.io/docs#getting_started) page.
    `,
        github_link_text: `Run with BlueQubit`,
        sign_up_link: {
          text: `Visit BlueQubit`,
          url: `https://www.bluequbit.io/`,
        },
        disclaimer: ``,
      },
    },
    qbraid: {
      button_label: `Launch on qBraid`,
      modal: {
        description: `
  ![](https://assets.cloud.pennylane.ai/pennylane_website/pages/demonstrations/hardware_modal/qbraid.png)
  ## Launch on qBraid
  qBraid Lab is a web-based JupyterLab deployment providing curated software tools for researchers and developers in quantum computing.
  
  Click on the "Launch on qBraid" button to access the notebook for this demo in your qBraid account.

  If you don't have an account yet, [try qBraid for free](https://account.qbraid.com/).

  Once you've launched on qBraid, double-click on the demo you want to run and choose a PennyLane kernel on the top-right of the notebook.
  See an example in the [qBraid docs](https://docs.qbraid.com/lab/user-guide/notebooks#switch-notebook-kernel).
  
  To learn more — visit qBraid's [website](https://www.qbraid.com/), [GitHub](https://github.com/qBraid/) and [docs](https://docs.qbraid.com/lab/user-guide/overview).
    `,
        github_link_text: `Launch on qBraid`,
        sign_up_link: {
          text: `Try qBraid for free`,
          url: `https://account.qbraid.com/`,
        },
        disclaimer: ``,
      },
    },
  },
}
